import { useContextState } from "../../hooks/theme"

export const useStyles = (data?: { removeMargin?: boolean }) => {
  const { colors } = useContextState()
  return {
    hidden: {
      display: 'none',
    },
    icons: {
      svg: {
        color: colors.primary
      }
    },
    footer: {
      '&.MuiTypography-root': {
        maxWidth: '50px'
      }
    },
    container: ({ styleType }: { styleType: boolean | undefined }) => ({
      ...!styleType && {
        width: '100%',
      },
      display: 'flex',
      marginTop: !data?.removeMargin ? '-20px' : 0,
    }),
    buttons: {
      display: 'flex',
      gap: 2,
      padding: 1,
      '& .flex-col': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: .5
      },
      '& .red': { color: 'c_red.main' },
      '& .green': { color: 'c_green.main' },
      '& .blue': { color: 'secondary.main' },
      '& .Mui-disabled': { color: 'c_grey.100' }
    },
    button: {
      color: colors.color4,
    },
    buttonsFlex: {
      display: 'flex'
    }
  }
}
